// config/themes/adventure.theme.ts
import { Theme } from './ITheme';

const adventureTheme: Theme = {
  colors: {
    background: '#0F3D3E', // deep green background
    background2: '#145454', // secondary background
    background4: '#1A4A4B', // additional background layer
    slider: '#FFA500', // slider color
    text2: '#CCCCCC', // secondary text color
    autoplayBtBgborder: '#FFA50033', // autoplay button border
    qbet: '#FFA500', // quick bet color
    primary: '#f4a617ff', // orange highlights
    secondary: '#14ebb5ff', // lime accent
    text: '#FFFFFF', // white text
    overlay: 'rgba(15,61,62,0.7)', // semi-transparent overlay
    border: '#FFA50033', // orange border with transparency
    betborder: '#FFA50033', // bet border color
    betborderPress: '#cc8500', // bet border press color
    betbutton: '#145454', // bet button background
    stake: '#FFA500', // stake color
    betHover: '#FFA50066', // bet hover color
    betButtonHover: '#FFB733', // bet button hover color
    betButtonPress: '0 0 0 0.2rem rgba(255, 165, 0, 0.5)', // bet button press shadow
    betCancelHover: '#ff6b6b', // bet cancel hover color
    betCancelPress: '0 0 0 0.2rem rgba(255, 107, 107, 0.5)', // bet cancel press shadow
    betCancelPressMobile: '#cc5555', // bet cancel press mobile color
    betCashHover: '#FFB733', // bet cash hover color
    betCashPress: '0 0 0 0.2rem rgba(255, 183, 51, 0.5)', // bet cash press shadow
    betCashPressMobile: '#d99a1a', // bet cash press mobile color
    betButtonPressMobile: '#cc8f1a',
    // CancelBorderPress: '0 0 0 0.2rem #e1536180',
    // CashoutBorderPress: '0 0 0 0.2rem rgba(255, 183, 51, 0.5)',
  },
  fonts: {
    primary: 'Poppins, sans-serif',
    secondary: 'Arial, sans-serif',
    button: 'Poppins, sans-serif',
  },
  uiElements: {
    button: {
      borderRadius: '8px',
      padding: '10px 18px',
      fontSize: '15px',
    },
    card: {
      borderRadius: '12px',
      shadow: '0 5px 10px rgba(0,0,0,0.2)',
    },
    modal: {
      borderRadius: '16px',
      background: '#145454',
    },
  },
};

export default adventureTheme;
